// extracted by mini-css-extract-plugin
export var option = "_5i-1";
export var optionActive = "_5i-2";
export var pill = "_5i-0";